import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Interweave } from 'interweave';

import useConfigs from '../../hooks/useConfigs';

// ##### Estilos #####
const ServiceDesc = styled.div`
  padding: 0 1rem 2rem 1rem;

  img {
    max-width: 110%;
  }

  h3 {
    font-size: ${(props) => 22 * props.fontsizemultiplier};
    font-weight: bold !important;
    color: ${(props) => props.colortitle};
    text-align: center;
    letter-spacing: 0px;
    opacity: 1;
  }

  p {
    color: ${(props) => props.colortipografia};
    text-align: center;
    font-size: ${(props) => 15 * props.fontsizemultiplier};
  }
`;

const CustomButtonCard = styled.div`
  border: 2px solid var(--azul-ppal);
  padding: 0.5rem 3rem;
  border-radius: 98px;
  font-weight: bold;
  max-width: 80%;
  margin-top: 1rem;

  background-color: ${(props) =>
    props.themeSelected === 'light'
      ? props.theme.transparent
      : props.theme.blanco};
  a {
    color: ${(props) =>
      props.themeSelected === 'light'
        ? props.theme.azulVerde + '!important'
        : props.theme.darkVerde + '!important'};
    font-weight: bold;
  }
`;

const CustomButton = styled.a`
  background-color: ${(props) =>
    props.themeSelected === 'light'
      ? props.theme.azulVerde
      : props.theme.blanco};
  color: ${(props) =>
    props.themeSelected === 'light'
      ? props.theme.blanco
      : props.theme.darkVerde};
  font-size: ${(props) => 16 * props.fontSizeMultiplier};
  border: 1px solid;
  padding: 1rem 10rem;
  border-radius: 100px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
`;

const MotionDivCarousel = styled(motion.div)`
  cursor: grab;
  overflow: hidden !important;
  border-radius: 3px;
  margin: 2rem 0;
  position: relative;
  width: 100%;
`;

const MotionDivItems = styled(motion.div)`
  min-width: 30rem;
  width: 33%;
  margin: 0 10px;
  border-radius: 40px;

  img {
    pointer-events: none;
    width: 100%;
    border-radius: 40px 40px 397px 26px / 40px 40px 78px 28px;
    object-fit: cover;
  }
`;

const DivCardServices = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 15px;
  box-shadow: 0 2px 0 rgb(90 97 105 / 11%), 0 4px 8px rgb(90 97 105 / 12%),
    0 10px 10px rgb(90 97 105 / 6%), 0 7px 70px rgb(90 97 105 / 10%);
  margin: 2rem auto;
  transition: 0.5s ease;
  min-width: 30rem;
  width: 33%;
  height: 100%;

  background-color: ${(props) => props.background};

  min-width: 30rem;
  min-height: 400px;
  margin: 0 10px;
  border-radius: 40px;
`;

export const HorizontalCarouselImg = ({ data }) => {
  const { fontSizeMultiplier, theme, themeSelected, activeTheme } =
    useConfigs();

  const [width, setWidth] = useState(0);
  const carousel = useRef();
  const carouselWidth = setTimeout(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, 3000);

  useEffect(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, [carouselWidth]);

  const backgroundCard = {
    DEFAULT: activeTheme?.color_base_blanco,
    ROSADO: activeTheme?.color_base_1,
    DARK: activeTheme?.color_base_1,
  };

  const colorTitle = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorTipografia = {
    DEFAULT: activeTheme?.color_base_tipografia,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  return (
    <div>
      <MotionDivCarousel theme={theme} themeSelected={themeSelected}>
        <motion.div
          drag='x'
          dragConstraints={{ right: 0, left: -width - 50 }}
          whileTap={{ cursor: 'grabing' }}
          className='inner-carousel'
          ref={carousel}
        >
          {data
            ? data.map(
                (d, i) =>
                  d?.activo && (
                    <MotionDivItems
                      theme={theme}
                      themeSelected={themeSelected}
                      key={d.name + '-' + i}
                    >
                      <DivCardServices
                        background={backgroundCard[activeTheme?.nombre]}
                      >
                        <img src={d.imagen} alt='imagen' />
                        <ServiceDesc
                          fontsizemultiplier={fontSizeMultiplier}
                          colortitle={colorTitle[activeTheme?.nombre]}
                          colortipografia={colorTipografia[activeTheme?.nombre]}
                        >
                          <h3>{d.titulo}</h3>
                          <p>
                            <Interweave content={d.texto_completo} />
                          </p>
                        </ServiceDesc>
                      </DivCardServices>
                    </MotionDivItems>
                  )
              )
            : 'loading'}
        </motion.div>
      </MotionDivCarousel>
    </div>
  );
};
